import React, { Component } from 'react'
import axios from 'axios'
import { APIURL } from '../../../config/config'
import { Modal, ModalBody } from 'reactstrap'
import { connect } from 'react-redux'
import ReceiptsForm from '../ReceiptsForm/ReceiptsForm'
import ReceiptsListRow from '../ReceiptsListRow/ReceiptsListRow'

class ReceiptsList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      lists: [],
      load_data: true,
      danger: false,
      receipts: '',
      toggle_receipts: false,
      receipts_id: 0,
      user: {},
      w_receipts_image_file: false,
    }
    this.toggleReceipts = this.toggleReceipts.bind(this)
    this.onDeleteHandle = this.onDeleteHandle.bind(this)
  }

  loadReceiptsData () {
    axios.get(APIURL + '/receipts/3') //3 = รายรับของเต็นท์รถ
      .then(res => {
        //console.log(res.data)
        this.setState({lists: res.data})
      }).catch(error => {
        this.setState({lists: []})
    })
  }

  componentWillMount () {
    this.setState({
      user: JSON.parse(this.props.user)
    })
  }

  componentDidMount () {
    //if(this.state.load_data)
    this.loadReceiptsData()
  }

  toggleReceipts () {
    this.setState({
      toggle_receipts: !this.state.toggle_receipts
    },() => this.loadReceiptsData())
  }

  onDeleteHandle(receipt) {

    if(window.confirm('ยืนยันการลบรายการ '+receipt.receipts_name)){
      var receipts_id = receipt.receipts_id
      var receipts_image_file = receipt.receipts_image_file
      var data = {
        receipts_image_file: receipts_image_file
      }

      axios.put(APIURL+'/receipts/'+receipts_id, data)
        .then(res => {
          if(res.status === 200){
            this.loadReceiptsData()
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }

  render () {
    return (
      <div className="card">
        <div className="card-block">
          <div className="row">
            <div className="col-sm-12 col-md-12">
              <div className="card card-accent-info">
                <div className="card-header">
                  <strong> ข้อมูลรายรับ </strong>
                  <button type="button"
                          onClick={this.toggleReceipts}
                          className="btn btn-primary float-right">
                    <i className="icon-plus"></i>&nbsp; เพิ่มข้อมูลรายรับ
                  </button>
                  <Modal isOpen={this.state.toggle_receipts} toggle={this.toggleReceipts}
                         className={'modal-lg'}>
                    <ModalBody>
                      <ReceiptsForm
                        onToggle={this.toggleReceipts}
                      />
                    </ModalBody>
                  </Modal>
                </div>

                <ReceiptsListRow
                   receipts_list={this.state.lists}
                   onDeleteHandle={this.onDeleteHandle}
                />

              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(ReceiptsList)